import { set } from 'nprogress';
import React, { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    Intercom?: (event: string, options?: { [key: string]: any }) => void;
  }
}

const Intercom: FC = () => {
  const therapistData = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data
  );

  const [initiated, setInitiated] = useState(false);
  const [currentUserId, setCurrentUserId] = useState<string | null>(null);

  useEffect(() => {
    // If user logged out or changed, shutdown previous session
    if (!therapistData?.firstName && initiated) {
      if (window.Intercom) {
        window.Intercom('shutdown');
      }
      setInitiated(false);
      setCurrentUserId(null);
      return;
    }

    // If a different user is logging in, shutdown previous session first
    if (therapistData?.providerId && currentUserId && currentUserId !== therapistData.providerId) {
      if (window.Intercom) {
        window.Intercom('shutdown');
      }
      setInitiated(false);
    }

    // Boot Intercom for the current user
    if (therapistData?.firstName && !initiated && window.Intercom) {
      window.Intercom('boot', {
        api_base: 'https://api-iam.intercom.io',
        app_id: 'vz5ddvwr',
        name: therapistData?.firstName + ' ' + therapistData?.lastName,
        user_id: therapistData?.providerId,
        email: therapistData?.email,
      });
      setInitiated(true);
      setCurrentUserId(therapistData.providerId);
    }
  }, [therapistData, initiated, currentUserId]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (initiated && window.Intercom) {
        window.Intercom('shutdown');
      }
    };
  }, [initiated]);

  const location = useLocation();

  useEffect(() => {
    if (window.Intercom) {
      window.Intercom('update');
    }
  }, [location.pathname]);

  return <></>;
};

export default Intercom;
